import React, { useEffect } from 'react';
import { useGamificationStore } from '../../../../utils/gamificationStore';
import { LevelCardItem } from './LevelCardItem';
import { ClassStatusCard } from './ClassStatusCard';
import './level-status.scss';

interface LevelStatusTabProps {
  t: (key: string) => string;
}

export const LevelStatusTab: React.FC<LevelStatusTabProps> = ({ t }) => {
  const { levelsStatus, isLevelsLoading, fetchLevelsStatus } = useGamificationStore();

  useEffect(() => {
    fetchLevelsStatus();
  }, [fetchLevelsStatus]);

  if (isLevelsLoading && !levelsStatus) {
    return (
      <div className="v2-level-status-tab__loader">
        <div className="v2-level-status-tab__skeleton-card" />
        <div className="v2-level-status-tab__skeleton-card" />
        <div className="v2-level-status-tab__skeleton-card" />
      </div>
    );
  }

  const levelsList = levelsStatus?.levels || [];
  const activeIndex = levelsList.findIndex(lvl => lvl.is_current_level);
  const remainingLevels = activeIndex !== -1 ? Math.max(0, levelsList.length - 1 - activeIndex) : 0;

  const remainingTextFormatted = t('remainingLevels').replace('{{count}}', String(remainingLevels));

  return (
    <div className="v2-level-status-tab">
      <div className="v2-level-status-tab__header">
        <h3 className="v2-level-status-tab__section-title">
          <span>{t('wayToTheTop')} </span>
          <span className="v2-level-status-tab__remaining-text">
            {remainingTextFormatted}
          </span>
        </h3>
      </div>

      {levelsStatus?.group_status && (
        <div className="v2-level-status-tab__benchmark-wrapper">
          <ClassStatusCard groupStatus={levelsStatus.group_status} t={t} />
        </div>
      )}

      <div className="v2-level-status-tab__grid">
        {levelsList.map((level) => (
          <LevelCardItem key={level.id || level.key} level={level} t={t} />
        ))}
      </div>
    </div>
  );
};
